import { Component, OnInit, Input, NgZone } from '@angular/core';
import { ListComponent } from '../../../shared/list/list.component';
import { RewardService } from '../reward.service';
import { ListService } from '../../../shared/list-service.service';
import { ActionsCellRenderer } from '../../../shared/list/renderer/actions-cell.renderer';
import { AG_GRID_LOCALE_EN } from '../../../shared/list/locale/en.locale';
import { DecimalPipe } from '@angular/common';
import { AuthService } from 'src/app/auth-module/auth.service';

@Component({
  selector: 'app-reward-list',
  templateUrl: './reward-list.component.html',
  styleUrls: ['./reward-list.component.css'],
  providers: [ListService, DecimalPipe]
})
export class RewardListComponent extends ListComponent implements OnInit {

  private gridApi;
  public gridOptions: any;
  public gridLocale;
  @Input() visible: boolean;

  constructor(
    private zone: NgZone,
    public service: RewardService,
    public listService: ListService,
    public auth: AuthService) {
    super(service, listService);
    this.setObject('reward');
  }

  ngOnInit() {
    if(this.auth.currentUserValue.user.role == 'Merchant'){
			this.service.merchantId = this.auth.currentUserValue.user.merchant.id;
		}else{
			this.service.merchantId = this.route.firstChild.snapshot.paramMap.get('idMerchant');
		}
    this.gridLocale = AG_GRID_LOCALE_EN;
    this.gridOptions = {
      columnDefs: [
        { headerName: '#', field: 'id', sortable: true, width: 60 },
        { headerName: 'reward.form.title', field: 'title', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'reward.form.start', field: 'reward_start', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'reward.form.stop', field: 'reward_stop', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        { headerName: 'reward.redeem', field: 'trigger_coupon_redeem', sortable: true, headerValueGetter: this.localizeHeader.bind(this) },
        {
          headerName: 'reward.form.status',
          field: 'status',
          sortable: true,
          cellRenderer: params => {
            if (params.value) {
              return this.translate.instant('reward.active');
            } else {
              return this.translate.instant('reward.inactive');
            }
          },
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'list.actions',
          field: 'id',
          cellRenderer: 'actionsCellRenderer',
          cellRendererParams: {
            actions: [
              {
                icon: 'ver_active2x.png',
                action: (id) => {
                  this.zone.run(() => {
                    this.show(id);
									});
                }
              },
              {
                icon: 'icon_editar2x.png',
                action: (id) => {
                  this.zone.run(() => {
										this.edit(id);
									});
                }
              },
              {
                icon: 'icon_borrar2x.png',
                action: (id) => {
                  this.delete(id);
                }
              }
            ]
          },
                headerValueGetter: this.localizeHeader.bind(this)
        }
      ],
      frameworkComponents: {
        'actionsCellRenderer': ActionsCellRenderer
      }
    };

    this.loadData();
  }

  show(id){
    this.router.navigate(['/'+this.object + '/'+this.service.merchantId +'/view/'+id]);
  }

  edit(id){
    this.router.navigate(['/'+this.object + '/'+this.service.merchantId +'/edit/'+id]);
  }

  onFilterTextBoxChanged(value): void {
    this.gridApi.setQuickFilter(value);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.refreshHeader();
    if(this.visible)
      this.sizeColumns();
  }

  sizeColumns(){
		this.gridApi.sizeColumnsToFit();
		window.onresize = () => {
			this.gridApi.sizeColumnsToFit();
		}
	}

}
